"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.epsilon = 0.00001;
//# sourceMappingURL=constants.js.map